import { Box, Button } from '@mui/material';
import React from 'react';

export const Advertisement: React.FC = (): JSX.Element => {
  return (
    <Box
      sx={{
        position: 'relative',
        backgroundImage: "url('/dummy/ads/PM-targets.jpeg')",
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        height: '300px',
      }}
    >
      <Button
        variant="contained"
        color="secondary"
        sx={{
          position: 'absolute',
          bottom: '15px',
          left: '50%',
          fontWeight: 'bold',
          transform: 'translate(-50%, 0)',
        }}
      >
        Meer info
      </Button>
    </Box>
  );
};
